export function resetForm() {
  window.dispatchEvent(new CustomEvent("resetAll"));
}
